import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { UserService } from '../user-management/service/user.service';
import validationform from '../../../../validation/validationform';
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../../components/login/service/login.service';
import intlTelInput from 'intl-tel-input';
@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrl: './new-user.component.scss'
})
export class NewUserComponent {
  getUserList: any = [];
  newUserForm!: FormGroup;
  addUserData!: object;
  getUserId2!: number;
  spinner: boolean = false;
  submitted = false;
  userDetails: any;
  userSubscription!: number;
  private readonly notifier: NotifierService;
  @Output() newUserEmit = new EventEmitter();
  @Output() addNewUser = new EventEmitter();
  countryCode1: any;
  countryCode2: any;
  initContry:any;

  @ViewChild('intlInput') intlInput!: ElementRef;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userListService: UserService,
    private notifierService: NotifierService,
      private service:LoginService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    let user:any = localStorage.getItem("user");
    var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
    const userRole = JSON.parse(data);
    this.userDetails = userRole;
    if(this.userDetails.hasOwnProperty('plan_id')){
      this.userSubscription = this.userDetails?.plan_id;
    }else{
       this.userSubscription = 1;
    }
   
    this.newUserForm = this.fb.group({
      username: ['', [Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      role: ['', Validators.required],
      email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      phonenumber: [
        '',
        [Validators.required, Validators.pattern('[- +()0-9]+.{9,}'),Validators.maxLength(10)],
      ],
    });
  }
  goSettings() {
    this.router.navigate(['/main/settings']);
  }
  get f(): { [key: string]: AbstractControl } {
    return this.newUserForm.controls;
  }

  pressCancel() {
    this.newUserEmit.emit(1);
    this.router.navigate(['main/postcall/userManagement/', 1]);
  }

  onSubmit() {
    this.submitted = true;
    if (this.newUserForm.valid) {
      this.spinner = true;
      this.submitted = false;
      const value = this.newUserForm.controls['phonenumber'].value;
      this.countryCode2 = this.initContry.getSelectedCountryData().dialCode;
      if (!value.includes('+91')) {
        this.newUserForm.controls['phonenumber'].setValue(
          '+' +
            (this.countryCode2
              ? this.countryCode2
              : this.countryCode1
            ).toString() +
            this.newUserForm.controls['phonenumber'].value
        );
      }
      this.addUserData = this.newUserForm.value;
      this.userListService.addUser(this.addUserData).subscribe(
        (sub) => {
          this.newUserForm.reset();
          this.addNewUser.emit(this.addUserData);
          this.notifier.notify('default', 'New User Created !');
          this.spinner = false;
          this.submitted = false;
        },
        (error) => {
          console.log('new user error', error.error.result);
          this.spinner = false;
          this.notifier.notify('default', error.error.result);
        }
      );
    } else {
      validationform.ValidateAllFormFields(this.newUserForm);
    }
  }

  getNumber(event: any) {}

  onCountryChange(event: any) {
    this.countryCode2 = event?.dialCode;
  }

  hasError(event: any) {}

  telInputObject(event: any) {
    this.countryCode1 = event.s.dialCode;
  }

   ngAfterViewInit() {
      this.initContry = intlTelInput(this.intlInput.nativeElement, {
        allowDropdown: true,
        nationalMode: true,
        initialCountry: 'in',
        separateDialCode: false
      });
    
      //controller.setCountry('JP');
      //controller.setNumber('9726502930');
    }

}
